function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5865 17.7498C16.034 17.1973 15.1358 17.1944 14.5805 17.7469L9.91682 22.4134L8.08649 20.5803C7.53399 20.0278 6.63582 20.0278 6.08332 20.5803C5.53082 21.1328 5.53082 22.0309 6.08332 22.5834L8.91665 25.4168C9.19149 25.6944 9.55415 25.8333 9.91682 25.8333C10.2795 25.8333 10.6422 25.6944 10.9198 25.4196L16.5865 19.7529C17.139 19.2004 17.139 18.3023 16.5865 17.7498Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5865 29.0828C16.034 28.5303 15.1358 28.5275 14.5805 29.08L9.91682 33.7465L8.08649 31.9161C7.53399 31.3636 6.63582 31.3636 6.08332 31.9161C5.53082 32.4686 5.53082 33.3668 6.08332 33.9193L8.91665 36.7526C9.19149 37.0275 9.55415 37.1663 9.91682 37.1663C10.2795 37.1663 10.6422 37.0275 10.9198 36.7526L16.5865 31.086C17.139 30.5335 17.139 29.6353 16.5865 29.0828Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M26.9163 20.1665H21.2497C20.4677 20.1665 19.833 20.8012 19.833 21.5832C19.833 22.3652 20.4677 22.9998 21.2497 22.9998H26.9163C27.6983 22.9998 28.333 22.3652 28.333 21.5832C28.333 20.8012 27.6983 20.1665 26.9163 20.1665Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M26.9163 31.4995H21.2497C20.4677 31.4995 19.833 32.1342 19.833 32.9162C19.833 33.6982 20.4677 34.3328 21.2497 34.3328H26.9163C27.6983 34.3328 28.333 33.6982 28.333 32.9162C28.333 32.1342 27.6983 31.4995 26.9163 31.4995Z",
  fill: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M31.1667 5.99967H25.5V4.58301C25.5 3.80101 24.8653 3.16634 24.0833 3.16634H21.0092C20.4227 1.51734 18.8473 0.333008 17 0.333008C15.1527 0.333008 13.5773 1.51734 12.9908 3.16634H9.91667C9.13467 3.16634 8.5 3.80101 8.5 4.58301V5.99967H2.83333C1.27217 5.99967 0 7.27184 0 8.83301V42.833C0 44.3942 1.27217 45.6663 2.83333 45.6663H31.1667C32.7278 45.6663 34 44.3942 34 42.833V8.83301C34 7.27184 32.7278 5.99967 31.1667 5.99967ZM11.3333 5.99967H14.1667C14.9487 5.99967 15.5833 5.36501 15.5833 4.58301C15.5833 3.80101 16.218 3.16634 17 3.16634C17.782 3.16634 18.4167 3.80101 18.4167 4.58301C18.4167 5.36501 19.0513 5.99967 19.8333 5.99967H22.6667V8.83301H11.3333V5.99967ZM31.1667 42.833H2.83333V8.83301H8.5V10.2497C8.5 11.0317 9.13467 11.6663 9.91667 11.6663H24.0833C24.8653 11.6663 25.5 11.0317 25.5 10.2497V8.83301H31.1667V42.833Z",
  fill: "currentColor"
});

function SvgOffer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 46,
    viewBox: "0 0 34 46",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer);
export default __webpack_public_path__ + "static/media/offer.4e57113f.svg";
export { ForwardRef as ReactComponent };